import React, {useRef, useEffect, useState, DragEvent} from 'react';
import {Popup, Flex, Button, Form, DurationPicker, Edit, Goals, Suggestions} from 'components';
import {useRafLoop, openPopup, useDrop, useGrabbed, useDragStart, pluralize, useFocusPopup, useSuggestionPopup, useAsyncAction, useSelector} from 'helpers';
import { delay } from 'redux-saga/effects';
import {activities, goals} from 'store';
import {select} from 'store/helpers';

const Test2 = () => {
  return (
    <Popup.Menu>
      <Popup.Menu.Item>Test</Popup.Menu.Item>
      <Popup.Menu.Item>Test2</Popup.Menu.Item>
    </Popup.Menu>
  );
};

const clicked = async () => {
  console.log(1)
  console.log(2)
};

export function Test() {
  console.log(useSelector(goals.examples))
  return (
    <main>
      <Flex className="justified">
        <Button {...useAsyncAction(clicked)}>Test</Button>
        <Button onClick={openPopup(Test2)}>Test</Button>
        <Button onClick={openPopup(Test2)}>Test</Button>
      </Flex>
      <Form initialValues={{test: 1, target_value: 2222}}>
        {({values}) =>
          <>
            <Edit type="number" name="target_value" label="Numerical Target" Suffix={Goals.NumberUnit} unitName="unit" />
            <pre>{ JSON.stringify(values, null, 2) }</pre>
          </>
        }
      </Form>
    </main>
  );
}

//          <label id={id} aria-haspopup>
//            <input placeholder='asdasd' ref={ref} onFocus={popup.open} />
//          </label>
//          <DurationPicker name="duration" />
